<template>
    <app-page-content>
        <app-sub-title text="Indicadores de Operación" />
        <app-dashboard-report v-if="!!client" :selected-client="client" />
    </app-page-content>
</template>
<script>
import DashboardReport from './DashboardReport/DashboardReport.vue';
export default {
    components: {
        appDashboardReport: DashboardReport
    }
}
</script>